import React from 'react';
import { CTAButton } from './CTAButton';
import { TrustRow } from './TrustRow';
import { BoxImage } from './BoxImage';
export function FinalCTA() {
  return <section className="py-6 px-4 sm:px-6 bg-navy text-white text-center" data-id="element-41" data-mp="3uei3hja6hw3x">
      <h2 className="text-lg sm:text-3xl font-heading font-extrabold text-gold uppercase leading-tight mb-2.5" data-id="element-42" data-mp="c8c0h6oh2he3">
        Un'Ultima Occasione
      </h2>

      <div className="max-w-2xl mx-auto text-[12.5px] sm:text-base text-cream/90 leading-relaxed space-y-1.5 mb-4" data-id="element-43" data-mp="m4ovc7vr71af">
        <p data-id="element-44" data-mp="h6n9xgauupvs">
          I tuoi atleti meritano programmi costruiti con metodo, non allenamenti
          improvvisati perché non hai avuto il tempo di pianificarli.
        </p>
        <p data-id="element-45" data-mp="qvx3l0lckgm0">
          Smetti di perdere ore ogni settimana tra programmi, sessioni,
          valutazioni, documentazione e pianificazioni. Smetti di cercare
          materiale in decine di libri, PDF, video e corsi.
        </p>
        <p data-id="element-46" data-mp="zxehqdf72882">
          Inizia a lavorare con un sistema professionale già pronto, progettato
          per aiutarti a preparare ogni allenamento in pochi minuti e offrire un
          servizio di livello superiore.
        </p>
        <p className="font-heading font-bold text-gold" data-id="element-47" data-mp="2h49hls4twhsy">
          Con RUNNING COACH PRO™ avrai finalmente tutto ciò di cui hai bisogno in
          un'unica soluzione.
        </p>
      </div>

      <BoxImage wrapperClassName="mb-3" className="max-w-[190px] drop-shadow-2xl" data-id="element-48" data-mp="2r3ibym3lvyfu" />

      <div className="bg-navy-dark border border-gold/40 rounded-lg p-3.5 mb-3 max-w-md mx-auto" data-id="element-49" data-mp="2v38ww96gbkcg">
        <p className="text-[11px] sm:text-sm font-heading font-bold uppercase tracking-wide text-white mb-0.5" data-id="element-50" data-mp="300sn87gfbnkr">
          🏃 RUNNING COACH PRO™
        </p>
        <p className="text-[12.5px] text-cream/85 mb-1.5" data-id="element-51" data-mp="39sygdkiewb1j">
          Sistema Completo 6-in-1 + 5 Bonus Premium
        </p>
        <p className="text-[13px] text-cream/60 mb-0.5" data-id="element-52" data-mp="3est3dcz2gghb">
          Prezzo di Listino: <span className="line-through" data-id="element-53" data-mp="3isboo9usutko">97€</span>
        </p>
        <p className="text-[28px] sm:text-4xl font-heading font-extrabold text-gold leading-none" data-id="element-54" data-mp="3iqqtci0nv6lr">
          Oggi Solo: 27€
        </p>
      </div>

      <div className="mb-1.5 max-w-lg mx-auto" data-id="element-55" data-mp="1eqbghxg0d8n6">
        <CTAButton className="bg-gold text-navy border-gold-dark hover:bg-gold-dark hover:text-white" data-id="element-56" data-mp="1enfgm3klo9w3">
          🚀 SÌ! VOGLIO RUNNING COACH PRO™
        </CTAButton>
      </div>
      <p className="text-[11px] sm:text-xs font-semibold text-cream/80 mb-2.5" data-id="element-57" data-mp="1nonfamr13cqp">
        Accesso Immediato • Consegna Istantanea via Email
      </p>

      <TrustRow dark data-id="element-58" data-mp="1xg9mm808wro6" />
    </section>;
}